import { defineStore } from 'pinia';
import { api } from '../lib/api';
export const useAuthStore = defineStore('auth', {
    state: () => ({
        setupStatus: null,
        user: JSON.parse(localStorage.getItem('casamb_user') || 'null'),
        loading: false
    }),
    getters: {
        isAuthenticated: state => !!localStorage.getItem('casamb_token') && !!state.user,
        isAdmin: state => state.user?.role === 'admin'
    },
    actions: {
        async loadSetupStatus() {
            if (!this.setupStatus)
                this.setupStatus = await api('/setup/status');
            return this.setupStatus;
        },
        async googleLogin(idToken) {
            const result = await api('/auth/google', {
                method: 'POST',
                body: JSON.stringify({ id_token: idToken, platform: 'web' })
            });
            localStorage.setItem('casamb_token', result.access_token);
            localStorage.setItem('casamb_user', JSON.stringify(result.user));
            this.user = result.user;
        },
        async refreshMe() {
            if (!localStorage.getItem('casamb_token'))
                return null;
            const user = await api('/auth/me');
            localStorage.setItem('casamb_user', JSON.stringify(user));
            this.user = user;
            return user;
        },
        logout() {
            localStorage.removeItem('casamb_token');
            localStorage.removeItem('casamb_user');
            this.user = null;
            location.href = '/login';
        }
    }
});
